import Vue from 'vue'
import router from './router'
import './guard'
import store from './store/store.js'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import { VueMaskDirective } from 'v-mask'
import App from './App.vue'

Vue.config.productionTip = false;
Vue.directive('mask', VueMaskDirective);

import api from './services/api';
import client from "./services/api";
Vue.prototype.$api = api;

import './plugins/money/money.js';

let vueApp = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// INTERCEPT REQUEST
client.interceptors.request.use(request => {
  store.dispatch('requests', true);
  var username = store.state.login.token;
  var password = '';
  var basicAuth = 'Basic ' + btoa(username + ':' + password);
  request.headers.common['Authorization'] = basicAuth;
  return request;
});

// INTERCEP RESPONSE
client.interceptors.response.use(
  function (response) {
    store.dispatch('requests', false);

    return response;
  },
  function (error) {
    if (error.code === 'ECONNABORTED' || error.response.status === 408) {
      vueApp.$root.$emit('GlobalSnackbar', { type: 'error', message:  'Um erro inesperado ocorreu. Entre em contato conosco.' });
      store.dispatch('requests', false);
      return Promise.reject(error);
    }

    if (error.response.status === 401) {
      vueApp.$root.$emit('GlobalSnackbar', { type: 'error', message:  error.response.data.errors });
      router.push({name: 'logout'});
    }
    else if (error.response.status !== 422) {
      vueApp.$root.$emit('GlobalSnackbar', { type: 'error', message: error.response.data.errors });
    }
    store.dispatch('requests', false);
    console.error('Request error ' + '(' + error.response.status + ' ' + error.response.statusText + ')', error.response);
    console.error('API erros (error.response.data.errors)', error.response.data.errors);

    return Promise.reject(error);
  }
);
